import { NextRequest, NextResponse } from 'next/server';
import { db, pool } from '@/lib/db';

export async function PUT(request: NextRequest) {
  try {
    const body = await request.json();
    const {
      email,
      firstName,
      businessName,
      phone,
      location,
      aboutGym,
      services,
      membershipPricing,
      membershipDescription,
      facilityFeatures,
      operatingHours,
      photos,
    } = body;

    if (!email) {
      return NextResponse.json(
        { error: 'Email is required' },
        { status: 400 }
      );
    }

    // Find gym by email
    const gyms = await db.gyms.findByOwnerEmail(email);
    
    if (gyms.length === 0) {
      return NextResponse.json(
        { error: 'Gym profile not found' },
        { status: 404 }
      );
    }

    const gymId = gyms[0].id;

    // Update gym profile
    await pool.execute(
      `UPDATE gyms SET 
        first_name = ?,
        business_name = ?,
        phone = ?,
        location = ?,
        about_gym = ?,
        services = ?,
        membership_pricing = ?,
        membership_description = ?,
        facility_features = ?,
        operating_hours = ?,
        photos = ?
      WHERE id = ?`,
      [
        firstName,
        businessName || null,
        phone,
        location,
        aboutGym,
        JSON.stringify(services),
        membershipPricing || null,
        membershipDescription,
        JSON.stringify(facilityFeatures),
        operatingHours ? JSON.stringify(operatingHours) : null,
        photos ? JSON.stringify(photos) : null,
        gymId
      ]
    );

    // Fetch updated gym
    const updatedGym = await db.gyms.findById(gymId);

    return NextResponse.json({
      success: true,
      message: 'Gym profile updated successfully',
      gym: updatedGym,
    });
  } catch (error) {
    console.error('Error updating gym profile:', error);
    return NextResponse.json(
      { error: 'Failed to update gym profile' },
      { status: 500 }
    );
  }
}
